import { RestaurantTagEdit } from "../../Component/RestaurantTag/RestaurantTagEdit";
import { constants } from "../../Constants/constants";

import "../../styles/map.css";

export const RestaurantCuisineEdit = () => {
  return (
    <RestaurantTagEdit resource={constants.PATH.RESTAURANT_TAG.RESTAURANT_CUISINE} resourceName="restaurant_cuisine" />
  );
};
